<template>
  <div class="add-address">
    <div class="main">
      <div class="header">
        <van-nav-bar
          title="添加角色"
          left-text=""
          left-arrow
          @click-left="onClickLeft"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    onClickLeft() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped></style>
